import { Form } from '@thinknet-gmbh/platform-common-ui';

import { StyledContainer } from './checkBox-field.styles';
import { IQuestionnaireFieldProps } from '../form-item-field/form-item-field.intrrface';

const CheckBoxField = ({ label, InputComponent, inputType, ...props }: IQuestionnaireFieldProps) => {
  if (!InputComponent) {
    return null;
  }
  return (
    <StyledContainer>
      <Form.Item valuePropName="checked" {...props}>
        <InputComponent>{label}</InputComponent>
      </Form.Item>
    </StyledContainer>
  );
};

export default CheckBoxField;
